import React from 'react';
import { NavLink } from 'react-router-dom';

const SideBar = () => {
  return (
    <aside className="side-bar">
      <nav>
        <ul>
          <li><NavLink to="/dashboard" end>Get Started</NavLink></li>
          <li><NavLink to="/dashboard/api-key">API Key</NavLink></li>
          <li><NavLink to="/dashboard/ontology">Ontology</NavLink></li>
          <li><NavLink to="/dashboard/knowledge-base">Knowledge Base</NavLink></li>
          <li><NavLink to="/dashboard/profile">Profile</NavLink></li>
        </ul>
      </nav>
    </aside>
  );
};

export default SideBar;
